module.exports = __webpack_public_path__ + "static/media/get-start-icon.6fd5905c.png";